var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2588 19.6738C22.2588 20.2043 22.0481 20.713 21.673 21.088C21.2979 21.4631 20.7892 21.6738 20.2588 21.6738H4.25879C3.72836 21.6738 3.21965 21.4631 2.84458 21.088C2.4695 20.713 2.25879 20.2043 2.25879 19.6738V5.67383C2.25879 5.1434 2.4695 4.63469 2.84458 4.25961C3.21965 3.88454 3.72836 3.67383 4.25879 3.67383H9.25879L11.2588 6.67383H20.2588C20.7892 6.67383 21.2979 6.88454 21.673 7.25961C22.0481 7.63469 22.2588 8.1434 22.2588 8.67383V19.6738Z",
    stroke: "#B0BEC5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2588 21.6738V20.0072C17.2588 19.1231 16.9954 18.2753 16.5266 17.6501C16.0577 17.025 15.4218 16.6738 14.7588 16.6738H9.75879C9.09575 16.6738 8.45986 17.025 7.99102 17.6501C7.52218 18.2753 7.25879 19.1231 7.25879 20.0072V21.6738",
    stroke: "#B0BEC5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2588 14.6738C13.6395 14.6738 14.7588 13.5545 14.7588 12.1738C14.7588 10.7931 13.6395 9.67383 12.2588 9.67383C10.8781 9.67383 9.75879 10.7931 9.75879 12.1738C9.75879 13.5545 10.8781 14.6738 12.2588 14.6738Z",
    stroke: "#B0BEC5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClient);
export default __webpack_public_path__ + "static/media/icon-client.62246a75400808664e47d3b4196b1c13.svg";
export { ForwardRef as ReactComponent };